import PropTypes from 'prop-types';

import { Arrow } from './arrow';
import { CarouselFlame } from './carousel-flame';
import { CarouselPepper } from './carousel-pepper';
import { Cross } from './cross';
import { DoubleX } from './double-x';
import { Flame } from './flame';
import { logger } from '../../utils/logger';
import { Pepper } from './pepper';
import { PepperHeart } from './pepper-heart';
import { PepperLowerHalf } from './pepper-lower-half';
import { PepperUpperHalf } from './pepper-upper-half';
import { ModalPattern } from './modal-pattern';
import { SlimSwatchPattern } from './slim-swatch-pattern';

const decals = {
  arrow: Arrow,
  doubleX: DoubleX,
  carouselPepper: CarouselPepper,
  carouselFlame: CarouselFlame,
  cross: Cross,
  flame: Flame,
  pepper: Pepper,
  pepperHeart: PepperHeart,
  pepperLowerHalf: PepperLowerHalf,
  pepperUpperHalf: PepperUpperHalf,
  modalPattern: ModalPattern,
  slimSwatchPattern: SlimSwatchPattern,
};
const decalNames = Object.keys(decals);

const Decal = ({ name, height, width, color, isAbsolute, ...rest }) => {
  const Component = decals[name];

  if (!Component) {
    logger.info('Missing decal', { name });
    return null;
  }

  return (
    <Component
      name={name}
      position={isAbsolute && 'absolute'}
      height={height}
      width={width}
      fill="currentColor"
      color={color}
      {...rest}
    />
  );
};

Decal.propTypes = {
  name: PropTypes.string.isRequired,
  height: PropTypes.string,
  width: PropTypes.string,
  color: PropTypes.string,
  isAbsolute: PropTypes.bool,
};

Decal.defaultProps = {
  height: '100%',
  width: '100%',
  color: null,
  isAbsolute: true,
};

export { Decal, decalNames };
